import React from 'react';

const NotFound: React.FC = () => {
  return (
    
    <div className="article article-error">
        
      <h1>404</h1>
      <p>Šī lapa neeksistē!</p>
      <p>This page does not exist!</p>
      <p>Эта страница не существует!</p>
    </div>
  );
};

export default NotFound;